import {TorchmarkFormController as controller} from './controller.js';
import templateUrl from './template.html';

export default {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        token: '@token',
        step: '=?step',
        formType: '=?formType',
        meta: '<',
        passthrough: '<',
        extraFields: '<',
        contact: '<',
        data: '<',
        debug: '<',
        config: '<',
        onSubmit: '@',
        doneCopy: '@'
    }
}



// WEBPACK FOOTER //
// ./app/torchmark/torchmark-form/component.js